export default function (http) {
    return {
        queryByCode(data){
            return http.json({
                url: `/system/dict/e/${data.code}`,
                data
            });
        },

        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryDictList(data) {
            return http.json({
                url: '/system/dict/tree',
                data
            })
        },
        /**
         * 获取字典详情
         * @param data
         * @return {*}
         */
        getDictInfo(data) {
            return http.json({
                url: `/system/dict/get?id=${data.id}`
            })
        },


        /**
         * 保存字典信息
         * @param data
         * @return {*}
         */
        saveDictInfo(data) {
            return http.json({
                url: '/system/dict/save',
                data
            })
        },

        /**
         * 删除字典
         * @param data
         * @return {*}
         */
        removeDict(data) {
            return http.json({
                url: `/system/dict/delete?id=${data[0].id}`
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/dict.js